import { useEffect } from 'preact/hooks';
import { stats, goBack, loadStats, showToast, friendlyError } from '../store.js';
import { __ } from '../i18n.js';
import { skipReasonLabel } from '../lib/labels.js';
import Header from '../components/Header.jsx';
import BackButton from '../components/BackButton.jsx';
import Icon from '../components/Icon.jsx';

export default function StatsScreen() {
  useEffect(() => {
    if (stats.value === null) {
      loadStats().catch((err) => showToast(friendlyError(err), 'error'));
    }
  }, []);

  return (
    <div>
      <BackButton onClick={goBack} label={__('Instellingen', 'etm')} />
      <Header title={__('Statistieken', 'etm')} />

      {stats.value === null ? (
        <p class="etm-screen-subtitle">{__('Bezig met laden…', 'etm')}</p>
      ) : (
        <>
          <div class="etm-stats-grid">
            <div class="etm-stat-card">
              <div class="etm-stat-value">{stats.value.completed}</div>
              <div class="etm-stat-label">{__('Voltooid', 'etm')}</div>
            </div>
            <div class="etm-stat-card">
              <div class="etm-stat-value">{stats.value.active}</div>
              <div class="etm-stat-label">{__('Actief', 'etm')}</div>
            </div>
            <div class="etm-stat-card">
              <div class="etm-stat-value">
                {stats.value.completion_rate === null
                  ? '—'
                  : `${Math.round(stats.value.completion_rate * 100)}%`}
              </div>
              <div class="etm-stat-label">{__('Voltooiingspercentage', 'etm')}</div>
            </div>
          </div>

          {stats.value.calibration_insight ? (
            <p class="etm-screen-subtitle">
              <Icon name="lightbulb" size={16} />{' '}
              {__('%s duren bij jou gemiddeld %sx je schatting', 'etm')
                .replace('%s', stats.value.calibration_insight.category_name)
                .replace('%s', stats.value.calibration_insight.ratio.toFixed(1))}
            </p>
          ) : null}

          <p class="etm-screen-subtitle">{__('Meest overgeslagen redenen', 'etm')}</p>

          {stats.value.skip_reasons.length ? (
            <div class="etm-task-list">
              {stats.value.skip_reasons.map((r) => (
                <div class="etm-task-list-item" key={r.reason}>
                  <div class="etm-task-list-item__body">
                    <div class="etm-task-list-item__title">{skipReasonLabel(r.reason)}</div>
                  </div>
                  <div class="etm-chip">{r.count}</div>
                </div>
              ))}
            </div>
          ) : (
            <p class="etm-field-hint">{__('Nog geen taken overgeslagen.', 'etm')}</p>
          )}
        </>
      )}
    </div>
  );
}
